var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaypalLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.4667 8.4667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.1492 2.3592c-0.019163 0.2963-0.097637 0.59692-0.22495 0.87644-0.39099 0.85845-1.2385 1.5178-2.0134 1.6541-0.77495 0.13631-1.4774-0.25061-1.8226 0.15883-0.34519 0.40945-0.33303 1.6152-0.40288 2.2196-0.027987 0.2422-0.069064 0.38773-0.12863 0.47519-0.076061 0.65087-0.050659 0.6591 0.12129 0.66194 0.20358 0.00336 0.61068 0.010021 0.93945 0.040974 0.32878 0.030953 0.57928 0.086045 0.67614-0.35505 0.096864-0.44109 0.040226-1.3782 0.32501-1.729 0.28479-0.35081 0.91082-0.11508 1.5323-0.30706 0.62152-0.19197 1.2385-0.81163 1.5191-1.5733 0.2806-0.76168 0.22468-1.6654-0.49854-2.1097-0.00724-0.00445-0.014985-0.00854-0.022364-0.012893z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.89888 6.2929c0.15654-1.2639 0.46963-3.7916 0.70341-5.0484 0.23377-1.2568 0.38811-1.2424 1.283-1.244 0.89489-0.0016933 2.5302-0.019477 3.3807 0.50048 0.85048 0.51996 0.91606 1.5775 0.52507 2.436s-1.2385 1.5178-2.0134 1.6541c-0.77495 0.13631-1.4773-0.25052-1.8225 0.15893s-0.33306 1.6151-0.40291 2.2196c-0.069845 0.60444-0.22174 0.60767-0.53704 0.60535-0.31531-0.0023215-0.79401-0.010204-1.0334-0.014146-0.2394-0.003942-0.2394-0.0039406-0.082854-1.2678z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaypalLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paypal_logo.56c5492c71d373c6c1e024e338f54546.svg";